import { registerPlugin } from '@capacitor/core';

export interface FacebookPlugin {
    getPermissions(options: { userId: string }): Promise<any>;
}

const FacebookPlugin = registerPlugin<FacebookPlugin>("FacebookPlugin");

export default FacebookPlugin;